export const ALLOWED_MIME_TYPES = [
  'image/jpg',
  'image/jpeg',
  'image/png',
  'video/mp4',
  'video/quicktime',
  'video/mpeg',
  'video/mpg',
  'application/pdf',
]

export const MAX_FILENAME_LENGTH = 255
export const MAX_FILE_SIZE = 524288000 // 500 MB
